export default __webpack_public_path__ + "static/media/collaborateur.4cf2be88.png";